import nlnAxios from "../../../api/nlnAxios";


//Register user
const register = async (userData) => {
    // console.log(userData);
    const response = await nlnAxios.post("/library/auth/", userData); 
    

    if(response.data){
        sessionStorage.setItem('user', JSON.stringify(response.data));
    }
    return response.data;
}

//Register user
const editUser = async (user) => {
    // console.log(userData);
    const response = await nlnAxios.patch(`/library/users/${user.userId}`, user); 
    

    // if(response.data){
    //     sessionStorage.setItem('user', JSON.stringify(response.data));
    // }
    return response.data;
}

    

//Login user

const login = async (userData) => {
    // console.log(userData);
    const response = await nlnAxios.post("/library/auth/login", userData); 
    

    if(response.data){
        // sessionStorage.setItem('user', JSON.stringify(response.data.data.token));
        sessionStorage.setItem('nln-virtual-library-user-token', JSON.stringify(response.data.data.token));
    }
    return response.data;
    }



    //logout user

    const logout = () => {
        sessionStorage.removeItem('user');
    }

// Get users 

const getUsers = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/users");

    return response.data;
}


    const authService = {
        register, 
        editUser,
        login, 
        logout,
        getUsers
    }

    export default authService;